// extracted by mini-css-extract-plugin
export default {"cls1":"NewLine-cls1_Z1L","cls2":"NewLine-cls2__JF NewLine-cls1_Z1L"};